




















import {Component, Prop, Vue} from 'vue-property-decorator'

@Component({
    components: {},
})
export default class DialogButtons extends Vue {
    @Prop({default: "キャンセル"}) private cancelText!: string;
    @Prop({default: "OK"}) private okText!: string;
    @Prop({default: true}) private enableCancel!: boolean;
    @Prop({default: true}) private enableOk!: boolean;
    @Prop({default: true}) private useCancel!: boolean;
    @Prop({default: true}) private useOk!: boolean;
}
